import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { BackgroundStains } from './BackgroundStains';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <BackgroundStains />
      <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      {children}
      <Footer />
    </div>
  );
}; 